const getImageDesStyle = (descriptionOptions) => {
    const position = descriptionOptions.position;

    let top = '';
    let bottom = '';
    let left= '';
    let right = '';
    let transform = '';
    const color = descriptionOptions.style.fontColor.length
        ? descriptionOptions.style.fontColor
        : 'inherit';
    const fontFamily = descriptionOptions.style.font.length
        ? descriptionOptions.style.font
        : 'inherit';

    switch (position.vertical) {
        case 'top':
            top = '32px';
            break;
        case 'center':
            top = '60%';
            transform = 'translateY(-50%)';
            break;
        case 'bottom':
            bottom = '32px';
            break;
        default:
            break;
    }

    switch (position.horizontal) {
        case 'left':
            if (position.vertical === 'bottom') {
                if (window.innerWidth > 1366) {
                    left = 'calc(430px + 32px)';
                    break;
                }
                if (window.innerWidth > 992) {
                    left = 'calc(360px + 32px)';
                    break;
                }
            
                if (window.innerWidth > 768) {
                    left = 'calc(300px + 32px)';
                    break;
                }
            }

            left = '32px';
            break;
        case 'center':
            left = '50%';
            transform = 'translateX(-50%)';
            break;
        case 'right':
            right = '32px';
            break;
        default:
            break;
    }

    if (position.vertical === 'center' && position.horizontal === 'center') {
        left = '50%';
        top = '50%';
        transform = 'translate(-50%, -50%)'
    }

    return {
        top,
        bottom,
        left,
        right,
        transform,
        color,
        fontFamily
    }
}

export default getImageDesStyle;